<div class="flex-auto bg-card">

    <!-- Header -->
    <div class="flex flex-row  justify-between items-center py-3 px-8 border-b">

        <!-- Title -->
        <div class="flex flex-row justify-between w-full">
            <div class="flex gap-4">
                <div class="text-2xl font-bold"> Listado de Registros Manual de Requerimientos</div>
                <button *appControlAcceso="'lectura'" matIconButton [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                    <mat-icon class="icon-size-5">build</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="descargarInforme()" [disabled]="descargandoInforme">
                        <mat-icon>arrow_circle_down</mat-icon>
                        <span>Descargar Informe</span>
                    </button>
                    <button mat-menu-item (click)="descargarReporte()" [disabled]="descargandoInforme">
                        <mat-icon>download</mat-icon>
                        <span>Descargar Reporte de Registros</span>
                    </button>
                    <button mat-menu-item (click)="abrirCargarPlantilla()">
                        <mat-icon>upload_file</mat-icon>
                        <span>Cargar plantilla</span>
                    </button>
                    <button mat-menu-item (click)="verHistorialInformes()">
                        <mat-icon>history</mat-icon>
                        <span>Ver Historial de informes</span>
                    </button>
                </mat-menu>
            </div>

            <div class="h-full">
                <button *appControlAcceso="'lectura'"
                    mat-flat-button [color]="'primary'" (click)="aregar()">Agregar Nuevo Registro</button>
            </div>
        </div>
    </div>

    <!--Filtros-->
    <div class="mx-8 mt-4 rounded-2xl border border-gray-200 bg-card p-4">
        <div class="flex gap-6 items-center">
            <div class="flex w-full gap-2">
                <!-- Profesional -->
                <div class="w-full md:w-4/12">
                    <mat-form-field  class="w-full fuse-mat-dense">
                        <mat-label>Profesional</mat-label>
                        <mat-select [(ngModel)]="profesionalSeleccionado" (selectionChange)="filtrar()">
                            <mat-option [value]="0">Todos</mat-option>
                            <mat-option *ngFor="let p of profesionales" [value]="p.descripcion">
                                {{ p.descripcion }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Área -->
                <div class="w-full md:w-4/12">
                    <mat-form-field  class="w-full fuse-mat-dense">
                        <mat-label>Área</mat-label>
                        <mat-select [(ngModel)]="areaSeleccionada" (selectionChange)="onAreaChange()">
                            <mat-option [value]="0">Todas</mat-option>
                            <mat-option *ngFor="let a of areasCarrera" [value]="a.descripcion">
                                {{ a.descripcion }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Subárea -->
                <div class="w-full md:w-4/12" *ngIf="cicloSeleccionado === cicloDiversificado">
                    <mat-form-field  class="w-full fuse-mat-dense">
                        <mat-label>Subárea</mat-label>
                        <mat-select [(ngModel)]="subareaSeleccionada" (selectionChange)="filtrar()">
                            <mat-option [value]="0">Todas</mat-option>
                            <mat-option *ngFor="let s of subareasCarrera" [value]="s.descripcion">
                                {{ s.descripcion }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Orientación -->
                <div class="w-full md:w-4/12" *ngIf="cicloSeleccionado !== cicloDiversificado">
                    <mat-form-field  class="w-full fuse-mat-dense">
                        <mat-label>Orientación</mat-label>
                        <mat-select [(ngModel)]="orientacionSeleccionada" (selectionChange)="onOrientacionChange()">
                            <mat-option [value]="0">Todas</mat-option>
                            <mat-option *ngFor="let o of orientacionesBasico" [value]="o.descripcion">
                                {{ o.descripcion }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Orientación Ocupacional -->
                <div class="w-full md:w-4/12" *ngIf="cicloSeleccionado !== cicloDiversificado">
                    <mat-form-field  class="w-full fuse-mat-dense">
                        <mat-label>Orientación Ocupacional</mat-label>
                        <mat-select [(ngModel)]="orientacionOcupacionalSeleccionada" (selectionChange)="filtrar()">
                            <mat-option [value]="0">Todas</mat-option>
                            <mat-option *ngFor="let o of orientacionesOcupacionalesBasico" [value]="o.descripcion">
                                {{ o.descripcion }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Tipo de Instituto -->
                <div class="w-full md:w-4/12" *ngIf="cicloSeleccionado !== cicloDiversificado">
                    <mat-form-field  class="w-full fuse-mat-dense">
                        <mat-label>Tipo de Instituto</mat-label>
                        <mat-select [(ngModel)]="tipoInstitutoSeleccionado" (selectionChange)="filtrar()">
                            <mat-option [value]="0">Todos</mat-option>
                            <mat-option *ngFor="let t of tiposInstituto" [value]="t.descripcion">
                                {{ t.descripcion }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <!-- Botón Filtrar -->
            <!--<div class="h-full">
                <button mat-flat-button class="bg-gray-500 text-white" (click)="filtrar()">Filtrar</button>
            </div>-->
        </div>
    </div>

    <mat-tab-group class="mx-8 mt-4" [selectedIndex]="tabIndex" (selectedIndexChange)="onTabChange($event)"
        mat-stretch-tabs="false"
        mat-align-tabs="start">
        <mat-tab label="Básico"></mat-tab>
        <mat-tab label="Diversificado"></mat-tab>
    </mat-tab-group>

    @if(!cargandoRegistros){
        <!-- Tabla de registros -->
        <div class="mx-8 mt-4 rounded-2xl border border-gray-200 p-6 bg-card">
            <app-tabla-registros
                [registros]="registrosFiltrados"
                [esBasico]="cicloSeleccionado !== cicloDiversificado"
                (eliminarRegistro)="eliminarRegistro($event)"
                (publicarRegistro)="publicarRegistro($event)">
            </app-tabla-registros>
        </div>

        <mat-paginator [length]="totalRegistros" [pageSize]="pageSize"></mat-paginator>
    }

    <ng-template #descargaDialog>
        <div class="p-6 flex items-center gap-4">
            <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
            <div class="text-base font-medium text-gray-700 leading-tight">
                {{ mensajeDescarga }}
            </div>
        </div>
    </ng-template>
</div>
